import { render, staticRenderFns } from "./LandscapeTip.vue?vue&type=template&id=1c8ceaba&scoped=true&"
import script from "./LandscapeTip.vue?vue&type=script&lang=js&"
export * from "./LandscapeTip.vue?vue&type=script&lang=js&"
import style0 from "./LandscapeTip.vue?vue&type=style&index=0&id=1c8ceaba&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c8ceaba",
  null
  
)

export default component.exports